<template>
  <div id="main">
    <div id="clock">
      <span id="hours">
        {{hours.tens}}{{hours.unit}}
      </span>
      <p>:</p>
      <span id="minutes">
        {{minutes.tens}}{{minutes.unit}}
      </span>
    </div>
    <div id="controls">
      <span
        class="iconContainers"
        id="play"
        @click="()=>{pausePlay()}"
      >
        <b-tooltip
          position="is-top"
          :label="$t('tooltip.play')"
          v-if="!running"
        >
          <b-icon
            pack="fas"
            icon="play-circle"
            v-if="!running"
          ></b-icon>
        </b-tooltip>
        <b-tooltip
          position="is-top"
          :label="$t('tooltip.pause')"
          v-if="running"
        >
          <b-icon
            pack="fas"
            icon="pause-circle"
            v-if="running"
          >
          </b-icon>
        </b-tooltip>
      </span>
      <span
        class="iconContainers"
        id="reset"
        @click="this.confirm"
      >
        <b-tooltip
          position="is-top"
          :label="$t('tooltip.reset')"
        >
          <b-icon
            pack="fas"
            icon="undo"
          ></b-icon>
        </b-tooltip>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'clock',
  data () {
    return {
      antiSpam: false,
      hours: {
        unit: 0,
        tens: 0
      },
      minutes: {
        unit: 0,
        tens: 0
      },
      seconds: 0,
      running: false
    }
  },
  props: {
    id: Number
  },
  created () {
    this.$socket.emit('room', 'Room_Brain_' + this.id)
    this.$socket.emit('brainTimer', 'Room_Brain_' + this.id, 'init')
    setInterval(() => { this.calculateDisplay() }, 1000)
  },
  methods: {
    calculateDisplay () {
      if (this.seconds > 59) {
        this.minutes.unit = Math.floor((this.seconds / 60) % 10)
        this.minutes.tens = Math.floor(this.seconds / 600) % 6
        this.hours.unit = Math.floor((this.seconds / 3600)) % 10
        this.hours.tens = (Math.floor(this.seconds / 36000) % 10)
      } else {
        this.minutes.unit = this.seconds % 10
        this.minutes.tens = ~~(this.seconds / 10)
      }
      if (this.running) {
        this.seconds += 1
      }
      if (this.running && this.seconds % 500 === 0 && this.seconds > 60 && !this.antiSpam) {
        this.antiSpam = !this.antiSpam
        setTimeout(() => {
          this.$socket.emit('brainTimer', this.id, 'sync')
          this.antiSpam = !this.antiSpam
        }, 1200)
      }
    },
    pausePlay () {
      this.$socket.emit('brainTimer', 'Room_Brain_' + this.id, 'pausePlay')
    },
    warn () {
      let message = this.seconds
      if (this.seconds > 0) {
        this.$socket.emit('sendWarn', 'Room_Brain_' + this.id, message)
      }
    },
    reset () {
      this.hours.tens = 0
      this.minutes.tens = 0
      this.hours.unit = 0
      this.minutes.unit = 0
      this.seconds = 0
    },
    confirm () {
      this.$buefy.dialog.confirm({
        message: this.$i18n.t('resetTimer'),
        onConfirm: () => {
          this.$socket.emit('brainTimer', 'Room_Brain_' + this.id, 'reset')
        }
      })
    }
  },
  sockets: {
    connect () {
      this.$store.commit('board/SOCKET_STATE', { state: true })
      var room = 'Room_Brain_' + this.id
      this.$socket.emit('room', room)
    },
    disconnect () {
      this.$store.commit('board/SOCKET_STATE', { state: false })
    },
    channel (data) {
      var decodeddata = JSON.parse(decodeURIComponent(data))
    },
    count (data) {
      this.userConnectedToRoom = data
    },
    syncing (data) {
      this.running = data.running
      this.seconds = data.seconds
      if (data.seconds === 0) {
        this.reset()
      }
      this.calculateDisplay()
    }

  }
}
</script>

<style scoped>
#main {
  display: flex;
  flex-flow: column nowrap;
  background-color: #3e6a99;
  width: auto;
  height: auto;
  border-radius: 5px;
  border: 2px solid white;
  color: white;
  margin-left: auto;
  margin-right: auto;
  font-size: 2em;
}

#clock {
  color: white;
  display: flex;
  flex-flow: row wrap;
  font-size: 5.6em !important;
  justify-content: center;
}
#controls {
  justify-content: center;
  display: flex;
  flex-flow: row nowrap;
  padding-top: 3px;
  font-size: 1.1em !important;
  justify-content: space-evenly;
}

.iconContainers {
  margin: 0 5px;
  cursor: pointer;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/board/toolbar/Clock.vue